<template>
    <component
        v-if="animation"
        :is="h(Transition, slot.default)"
        v-bind="$attrs"
    />
    <slot v-else @vue:unmounted="$emit('afterLeave')"></slot>
</template>

<script setup lang="ts">
import { useSettingsStore } from "@/store/settings-store";
import { storeToRefs } from "pinia";
import { refProp } from "@/composables/reactive";
import { h, Transition } from "vue";

const settingsStore = useSettingsStore();
const { settings } = storeToRefs(settingsStore);
const animation = refProp(settings, "animation");

defineOptions({
    inheritAttrs: false,
});

const slot = defineSlots<{
    default: (props: {}) => any;
}>();
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.15s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.popup-enter-active,
.popup-leave-active {
    transition:
        opacity 0.2s cubic-bezier(0.22, 1, 0.36, 1),
        transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.popup-enter-from,
.popup-leave-to {
    opacity: 0;
    transform: scale(0.9);
}

.container-toggle-enter-active,
.container-toggle-leave-active {
    overflow-y: hidden;
    transition:
        opacity 0.5s,
        height 0.5s !important;
}

.container-toggle-enter-from {
    opacity: 0;
}

.container-toggle-leave-to {
    opacity: 0;
}

.widgetsDrawer-enter-active,
.widgetsDrawer-leave-active {
    opacity: 1;
    transform: translateX(0);
    transition:
        transform 300ms cubic-bezier(0.23, 1, 0.32, 1),
        opacity 300ms cubic-bezier(0.23, 1, 0.32, 1);
}

.widgetsDrawer-enter-from,
.widgetsDrawer-leave-active {
    opacity: 0;
    transform: translateX(240px);
}

.widgetsDrawer-back-enter-active,
.widgetsDrawer-back-leave-active {
    opacity: 1;
    transition: opacity 300ms cubic-bezier(0.23, 1, 0.32, 1);
}

.widgetsDrawer-back-enter-from,
.widgetsDrawer-back-leave-active {
    opacity: 0;
}

.menuDrawer-enter-active,
.menuDrawer-leave-active {
    opacity: 1;
    transform: translateX(0);
    transition:
        transform 300ms cubic-bezier(0.23, 1, 0.32, 1),
        opacity 300ms cubic-bezier(0.23, 1, 0.32, 1);
}

.menuDrawer-enter-from,
.menuDrawer-leave-active {
    opacity: 0;
    transform: translateX(-240px);
}

.menuDrawer-back-enter-active,
.menuDrawer-back-leave-active {
    opacity: 1;
    transition: opacity 300ms cubic-bezier(0.23, 1, 0.32, 1);
}

.menuDrawer-back-enter-from,
.menuDrawer-back-leave-active {
    opacity: 0;
}

.tray-enter-active,
.tray-leave-active {
    opacity: 1;
    transform: translateX(0);
    transition:
        transform 300ms cubic-bezier(0.23, 1, 0.32, 1),
        opacity 300ms cubic-bezier(0.23, 1, 0.32, 1);
}

.tray-enter-from,
.tray-leave-active {
    opacity: 0;
    transform: translateX(-240px);
}

.tray-back-enter-active,
.tray-back-leave-active {
    opacity: 1;
    transition: opacity 300ms cubic-bezier(0.23, 1, 0.32, 1);
}

.tray-back-enter-from,
.tray-back-leave-active {
    opacity: 0;
}

.folder-toggle-enter-active,
.folder-toggle-leave-active {
    overflow-y: hidden;
    transition:
        opacity 0.5s,
        height 0.5s !important;
}

.folder-toggle-enter-from {
    opacity: 0;
}

.folder-toggle-leave-to {
    opacity: 0;
}
</style>
